import React, { useEffect, useReducer, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import PageTitle from "../../layouts/PageTitle";
import {
  addIntake,
  getIntakeById,
  updateIntake,
} from "../../../services/IntakeService";
import Swal from "sweetalert2";
import { Button } from "react-bootstrap";

const AddIntake = () => {
  const [loading, setLoading] = useState(false);
  const [intakeName, setIntakeName] = useState("");
  const hasFetched = useRef(false);
  const { id } = useParams();
  const [errors, setErrors] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (id && !hasFetched.current) {
      hasFetched.current = true;
      const fetchIntake = async () => {
        try {
          setLoading(true);
          const response = await getIntakeById(id);
          const intake = response?.data;
          setIntakeName(intake?.data?.title);
        } catch (err) {
          console.error("Error fetching intake:", err);
        } finally {
          setLoading(false);
        }
      };
      fetchIntake();
    }
  }, [id]);

  const validateForm = () => {
    const newErrors = {};

    if (!intakeName.trim()) {
      newErrors.intakeName = "Title is required";
    }

    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    try {
      // --- VALIDATE FORMS ---
      const formValid = validateForm();
      if (!formValid) {
        return;
      }
      const intakeData = { title: intakeName };

      setLoading(true);

      if (id) {
        // --- UPDATE EXISTING COUNTRY ---
        await updateIntake(id, intakeData);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Intake details updated successfully",
        });
        navigate("/intake", {
          state: {
            page: location.state?.page || 1,
            searchTerm: location.state?.searchTerm || "",
          },
        });
      } else {
        // --- CREATE NEW COUNTRY ---
        const response = await addIntake(intakeData);
        if (response.data.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Intake added successfully",
          });
          navigate("/intake", {
            state: {
              page: location.state?.page || 1,
              searchTerm: location.state?.searchTerm || "",
            },
          });
        }
      }
    } catch (err) {
      console.error("Error in handleSave:", err);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.response?.data?.message || "Operation failed",
      });
    } finally {
      // hide loader
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div id="preloader">
        <div className="sk-three-bounce">
          <div className="sk-child sk-bounce1"></div>
          <div className="sk-child sk-bounce2"></div>
          <div className="sk-child sk-bounce3"></div>
        </div>
      </div>
    );
  }
  return (
    <>
      <PageTitle
        activeMenu={`${id ? "Edit Intake" : "Add Intake"}`}
        motherMenu="Intake"
        activeMenuLink={`${id ? `edit-intake/${id}` : "add-intake"}`}
        motherMenuLink={"intake"}
      />
      <div className="row">
        <div className="col-xl-12">
          <div className="row">
            <div className="col-xl-12 col-xxl-12">
              <div className="card h-auto">
                <div className="card-body">
                  <form>
                    <div
                      onClick={() => {
                        navigate("/intake", {
                          state: {
                            page: location.state?.page || 1,
                            searchTerm: location.state?.searchTerm || "",
                          },
                        });
                      }}
                      className="mb-4 d-flex align-items-center flex-wrap gap-2 cursor-pointer w-max"
                    >
                      <i className="fas fa-chevron-left"></i>
                      <div>Intake List</div>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <input
                        type="text"
                        className="form-control w-full"
                        placeholder="Title"
                        value={intakeName}
                        onChange={(e) => setIntakeName(e.target.value)}
                      />
                      {errors.intakeName && (
                        <div className="text-danger mt-1">
                          {errors.intakeName}
                        </div>
                      )}{" "}
                      {/* Display validation error if any */}
                    </div>
                  </form>
                </div>
              </div>
              <hr style={{ margin: "0px" }} className="mx-2" />
              <div className="card-footer border-0 text-end py-3 d-flex justify-content-end gap-2">
                <Button
                  type="button"
                  variant="secondary"
                  className="btn btn-outline-secondary btn-sm"
                  onClick={() => {
                    navigate("/intake", {
                      state: {
                        page: location.state?.page || 1,
                        searchTerm: location.state?.searchTerm || "",
                      },
                    })
                  }}
                >
                  Back
                </Button>

                {/* Save / Update Button */}
                <Button
                  type="button"
                  className="btn btn-primary btn-sm"
                  onClick={handleSave}
                >
                  {id ? "Update" : "Save"}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddIntake;
